import React from 'react';
import { WithActions } from './actions';

// A page's collection takes one of two forms, and only these two: CARDS (the
// kit's ElementTable of ElementCells on a DeskTable, Shelf.js) and a TABLE
// (DataTable.js). Either way: a press opens the item in the inspector; a
// right-click offers the same actions its inspector's ActionBar does.
//
// A <Row> is neither: it is one line of a short list inside a panel (an
// inspector's band, a sheet), where a table has no room.

// A row may carry more lines under its sub (`children`: an error, a detail).
// A row to PICK (`onCheck`) is a label with its checkbox first: a press
// anywhere on it ticks it, `checked` says whether it is, `disabled` holds it.
export function Row({ name, sub, end, endTone, open, dim, onPress, actions, lead, checked, onCheck, disabled, children }) {
    const picking = typeof onCheck === 'function';
    const body = (
        <>
            {picking && <span className="nx-row__lead"><input type="checkbox" className="nx-row__check" checked={!!checked} disabled={disabled} onChange={onCheck} /></span>}
            {!picking && lead && <span className="nx-row__lead" aria-hidden="true">{lead}</span>}
            <span className="nx-row__main">
                <span className="nx-row__name">{name}</span>
                {sub && <span className="nx-row__sub">{sub}</span>}
                {children}
            </span>
            {end != null && <span className={`nx-row__end${endTone ? ` is-${endTone}` : ''}`}>{end}</span>}
        </>
    );
    if (picking) return <label className={`nx-row is-pick${checked ? ' is-on' : ''}${disabled ? ' is-held' : ''}${dim ? ' is-dim' : ''}`}>{body}</label>;
    const cls = `nx-row${open ? ' is-open' : ''}${dim ? ' is-dim' : ''}${onPress ? ' is-door' : ''}`;
    // A row with a menu wears the kit's ⋯ (reachable without a right-click, on
    // touch), and a button may not hold a button: that row is a focusable div.
    if (actions?.length) {
        return (
            <WithActions actions={actions} more>
                <div
                    className={cls}
                    {...(onPress ? {
                        role: 'button', tabIndex: 0, 'aria-pressed': !!open, onClick: onPress,
                        onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onPress(); } },
                    } : {})}
                >
                    {body}
                </div>
            </WithActions>
        );
    }
    return onPress
        ? <button type="button" className={cls} onClick={onPress} aria-pressed={!!open}>{body}</button>
        : <div className={cls}>{body}</div>;
}

// A cell with its right-click menu (the same actions as its inspector).
export function Cell({ actions, children }) {
    return actions?.length ? <WithActions actions={actions}>{children}</WithActions> : children;
}
